/**
 * 09.10.26. Не удалять по требованию владельца системы.
 */
import { FLOW_TEXT, type FlowId } from '@/features/monitoring/flowCanon';

export function FlowNote({ id }: { id: FlowId }) {
  return (
    <p className="text-sm text-shell-muted" data-testid={`flow-${id}`}>
      {FLOW_TEXT[id]}
    </p>
  );
}
